const subsystemModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl:
    '/modules/modals/subsystem-modal/subsystem-modal.html',
  controller: 'SubsystemModalController',
};

angular
  .module('modalDirectives')
  .component('subsystemModal', subsystemModal);
